//@flow

import store from '../../../admin/store'
import isIn from 'validator/lib/isIn'
import i18n from '../../../locales/i18n'

/**
 * Returns payload type
 */
const getPayloadType = (cheerOrganising: boolean, fromGroup: boolean, entityString: string): string|boolean => {
    if (entityString) {
        return entityString
    }

    return cheerOrganising || fromGroup ? 'groups' : 'events'
}

type CheerEntity = {
    organisingGroup: {
        data: {
            name: string,
        },
    },
    organised_by_group_id: number,
    additionalInfo?: {
        data: {
            organiser: string,
        },
    },
}

/**
 * Saves cheer
 */
const saveCheer = (fromGroup: boolean, cheerState: { isCheer: boolean }, entity: CheerEntity, type: string): void => (
    window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/cheers?type=${type}`).then(dataCheers => {
        if (!(isIn(`${entity.organised_by_group_id}`, dataCheers.data))) {

            if (!fromGroup && !cheerState.isCheer && type !== 'users') {
                const organiserName = entity && entity.additionalInfo && entity.additionalInfo.data ? entity.additionalInfo.data.organiser : null
                store.dispatch({
                    type: 'SET_CHEER_MODAL',
                    text: i18n.t('fanGroupQuestion.text', { group: organiserName }),
                    successAction: toggleCheer,
                    entity: entity,
                })
            }
        }
    })
)

type CheersApiResponse = {
    data: {
        total_entity_cheers_count: number,
    },
}

/**
 * Switches user cheer status by type of method (post or delete)
 */
export const switchUserCheerStatus = (method: string, payload: {}, cheerOrganising: boolean, entity: CheerEntity): Promise<CheersApiResponse> => {
    const state = store.getState()
    const cheerState = state.app.cheer

    return window.axios[method](`${window.APP_CONFIG.REACT_APP_API_URL}api/cheers`, payload)
        .then((response: CheersApiResponse) => {

            if (cheerState.busy) {
                store.dispatch({
                    type: 'TOGGLE_BUSY_CHEER',
                })
            }

            store.dispatch({
                type: 'SET_USER_IS_CHEER',
                userIsCheer: method === 'post',
            })

            return new Promise(resolve => resolve(response))
        })
        .then((response: CheersApiResponse) => {
            if (cheerOrganising) {
                store.dispatch({
                    type: 'SET_CHEER_MODAL',
                    text: i18n.t('fanGroupSuccessMessage', {
                        group: entity && entity.organisingGroup ? entity.organisingGroup.data.name : null,
                    }),
                })
            }

            return new Promise(resolve => resolve(response))
        })
}

/**
 * Triggers unauthorized user modal
 *
 * @returns {Promise<void>}
 */
const triggerUnauthedUserModal = () => {
    store.dispatch({
        type: 'SET_LOGIN_MODAL',
        text: i18n.t('fanGroup.unloggedUser.text'),
        successAction: toggleCheer,
    })

    return new Promise(resolve => resolve())
}

/**
 * Cheer / uncheer event/group by logged user
 */
export const toggleCheer = (cheerOrganising: boolean, fromGroup: boolean, entityString:string|null = null): any => {
    const state = store.getState()
    const cheerState = state.app.cheer
    const entity = cheerState.entity

    if (cheerState.busy) {
        return new Promise(resolve => resolve())
    }

    if (!state.auth.user) {
        return triggerUnauthedUserModal()
    }

    const type = getPayloadType(cheerOrganising, fromGroup, entityString)

    if (!cheerState.busy) {
        store.dispatch({
            type: 'TOGGLE_BUSY_CHEER',
        })
    }

    if (!cheerOrganising && !fromGroup && entity.organised_by_group_id !== null) {
        saveCheer(fromGroup, cheerState, entity, type)
    }

    let method = 'post'

    let payload = {
        id: cheerOrganising ? entity.organised_by_group_id : entity.id,
        type: type,
    }

    if (cheerState.isCheer && !cheerOrganising) {
        method = 'delete'
        payload = { params: payload }
    }

    return switchUserCheerStatus(method, payload, cheerOrganising, entity)
}

export default toggleCheer
